import { render, staticRenderFns } from "./viewRecord.vue?vue&type=template&id=6ea3ac66&"
import script from "./viewRecord.vue?vue&type=script&lang=js&"
export * from "./viewRecord.vue?vue&type=script&lang=js&"
import style0 from "./viewRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports